import type {
  GameContext,
  GameInstance,
  GameModule,
  PreloadContext,
} from '@arcraz/arcadia-types';
import { NeonOverpassInstance } from './instance.js';
import { PALETTE_HINT } from './palette.js';

/**
 * NEON OVERPASS — first cartridge.
 *
 * Top-down endless highway. Weave 3-lane traffic at neon speed.
 * Inspired by Pole Position + Spy Hunter, original mechanics.
 *
 * MVP scope (sc-2807): keyboard-only, basic traffic, score = ticks
 * survived, crash → GAME OVER → restart. Nitro mechanic, audio,
 * touch controls, server validation all land as follow-ups under
 * epic 2734.
 */
const module_: GameModule = {
  id: 'neon-overpass',
  title: 'NEON OVERPASS',
  manufacturer: 'ARCADIA AMUSEMENTS',
  year: 1984,
  genre: 'racing',
  resolution: { w: 480, h: 270 },
  pixelated: true,
  paletteHint: PALETTE_HINT,
  validatorVersion: 1,
  controls: [
    { keys: 'ARROWS / WASD', action: 'STEER + ACCEL' },
    { keys: 'UP / Z', action: 'ACCELERATE' },
    { keys: 'DOWN', action: 'BRAKE' },
    { keys: 'X', action: 'TURBO (HOLD)' },
    { keys: 'Z', action: 'RESTART (AT GAME OVER)' },
  ],

  async preload(ctx: PreloadContext): Promise<void> {
    // Crash: short noise burst.
    ctx.registerSfx('crash', {
      wave: 'noise',
      pitch: [{ t: 0, f: 80 }, { t: 200, f: 40 }],
      gain: [{ t: 0, g: 0 }, { t: 8, g: 0.55 }, { t: 200, g: 0.0 }],
    });
    // Lap chime: rising third, square wave.
    ctx.registerSfx('lap', {
      wave: 'square',
      pitch: [
        { t: 0, f: 660 },
        { t: 80, f: 660 },
        { t: 80, f: 880 },
        { t: 240, f: 880 },
      ],
      gain: [{ t: 0, g: 0 }, { t: 10, g: 0.3 }, { t: 240, g: 0.0 }],
    });
  },

  init(ctx: GameContext): GameInstance {
    return new NeonOverpassInstance(ctx);
  },
};

export default module_;
